// libs
import React, { memo } from 'react';
// dls
import { Text } from '@swiggy-private/dls-web-core/dist/components/Text';
// constants
import { DlsColorTokens, DlsFontVariants } from '@/constants/DLSTokens';
// widgets
import EditButton from '@/widgets/EditButton';
// helpers
import { formatNumberIntl, prefixWithRupee } from '@/helpers/utils';
// styles
import styles from '../ReviewCampaign.module.scss';
const Budget = ({ budget, pacingEnabled, setActiveStep }) => {
    const handleEditClick = () => {
        // Index 4 is for Budget screen
        setActiveStep(4);
    };
    return (React.createElement("div", { className: styles.budget },
        React.createElement("div", { className: styles.containerHeaderSub },
            React.createElement(Text, { variant: DlsFontVariants.subheader_S1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, "Budget"),
            React.createElement(EditButton, { label: "Edit", onClick: handleEditClick })),
        React.createElement("div", { className: styles.budgetContainer },
            React.createElement("div", { className: styles.budgetField },
                React.createElement(Text, { className: styles.budgetFieldKey, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Campaign Budget"),
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, prefixWithRupee(formatNumberIntl({ value: budget })))),
            React.createElement("div", { className: styles.budgetField },
                React.createElement(Text, { className: styles.budgetFieldKey, variant: DlsFontVariants.body_B1_Med, color: DlsColorTokens.text_Med_Emphasis }, "Daily pacing enabled"),
                React.createElement(Text, { variant: DlsFontVariants.body_B1_Bold, color: DlsColorTokens.text_Highest_Emphasis }, pacingEnabled === true ? 'Yes' : 'No')))));
};
export default memo(Budget);
